// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4e57b5db","498":"28439adc","554":"c95dc835","735":"64305151","954":"2e59fb31"}[chunkId] + ".chunk.js";
};